export default {
    template: '#properties-window-template',
    created: function () {
        var that = this;

        this.$on('item-select', function (data) {
            that.onItemSelected();
            setTimeout(function () {
                that.bindSelect();
            }, 200);
        });

        this.$on('force-select', function () {
            that.onItemSelected();
            setTimeout(function () {
                that.bindSelect();
            }, 200);
        });

        this.$on('item-unselect', function () {
            that.onItemUnSelected();
        });

        this.loadAssets();
    },
    async attached() {
      let exoFont = document.createElement('div');
      exoFont.innerText = 'Exo';
      exoFont.style.fontFamily = 'Exo';
      document.body.appendChild(exoFont);

      await this.$nextTickPromise();

      exoFont.remove();
    },
    data: function () {
        return {
            popOver: {
                popoverTitle: '',
                style: {
                    top: '100px',
                    left: '',
                    display: 'none'
                }
            },
            popOverArrow: {
                top: '40px'
            },
            option: {
                display: 'none'
            },
            fonts: [],
            text_colors: [],
            currentSelectedItem: {}
        }
    },
    props: ['item'],
    methods: {
        onItemSelected: function (data) {
            this.$set('currentSelectedItem', this.$root.selectedItem);
            if (this.currentSelectedItem.type == 'TEXT' || this.currentSelectedItem.type == 'ARTWORK') {
                this.setPopoverTitle();
                this.setPopoverStyle();
                this.setOptionStyle();
                this.setPopoverPosition();

                var that = this;
                var item = this.currentSelectedItem;
                if (this.currentSelectedItem.type == 'TEXT') {
                    setTimeout(function () {
                        if ($('#colorselector')) {
                            $('#colorselector').colorselector({
                                callback: function (value) {
                                    var oldColor = that.currentSelectedItem.element.fill;
                                    that.$root.removeColors(oldColor, that.$root.currentSide);
                                    that.$root.storeColors(value, that.$root.currentSide);
                                    that.$set('currentSelectedItem.element.fill', value);
                                    that.$root.setMainProductPricing();
                                }
                            }).colorselector('setColor', item.element.fill);
                        }
                    }, 100);

                    setTimeout(function () {
                        if ($('#colorselector_outline')) {
                            $('#colorselector_outline').colorselector({
                                callback: function (value) {
                                    if (parseInt(that.currentSelectedItem.element.stroke_width, 10) > 0) {
                                        var oldColor = that.currentSelectedItem.element.stroke;
                                        that.$root.removeColors(oldColor, that.$root.currentSide);
                                        that.$root.storeColors(value, that.$root.currentSide);
                                    }
                                    that.$set('currentSelectedItem.element.stroke', value);
                                    that.$root.setMainProductPricing();
                                }
                            }).colorselector('setColor', item.element.stroke);
                        }
                    }, 100);
                } else if (this.currentSelectedItem.type == 'ARTWORK') {
                    setTimeout(function () {
                        if ($('#colorselector_art_color')) {
                            $('#colorselector_art_color').colorselector({
                                callback: function (value) {
                                    var oldColor = that.currentSelectedItem.element.fill;
                                    that.$root.removeColors(oldColor, that.$root.currentSide);
                                    that.$root.storeColors(value, that.$root.currentSide);
                                    that.$set('currentSelectedItem.element.fill', value);
                                    that.$root.setMainProductPricing();
                                }
                            }).colorselector('setColor', item.element.fill);
                        }
                    }, 100);
                }
            }
        },
        onItemUnSelected: function () {
            this.$set('currentSelectedItem', null);
            this.$set('popOver.style.display', 'none');
        },
        setPopoverTitle: function () {
            if (this.$root.selectedItem == null) {
                this.$set('popOver.popoverTitle', '');
            } else {
                var item = this.$root.selectedItem;
                if (item.type == "TEXT") {
                    this.$set('popOver.popoverTitle', 'Edit Text');
                } else if (item.type == "ARTWORK") {
                    this.$set('popOver.popoverTitle', 'Edit Artwork');
                }
            }
        },
        setPopoverStyle: function () {
            if (this.$root.selectedItem == null) {
                this.$set('popOver.style.top', '0px');
                this.$set('popOver.style.display', 'none');
            } else {
                this.$set('popOver.style.top', this.popOver.style.top);
                this.$set('popOver.style.left', this.popOver.style.left);
                this.$set('popOver.style.display', 'block');
            }
        },
        setOptionStyle: function () {
            if (this.$root.selectedItem == null) {
                this.$set('option.display', 'none');
            } else {
                this.$set('option.display', 'block');
            }
        },
        setPopoverPosition: function () {
            if (this.$root.selectedItem == null) {
                this.$set('popOver.style.top', '0px');
                this.$set('popOver.style.left', '0px');
                this.$set('popOver.style.display', 'none');
            } else {
                var design_area = $('#app-wrap .labView.active .design-area');
                var top = design_area.offset().top;
                var left = design_area.offset().left + design_area.width();
                this.$set('popOver.style.top', top + 'px');
                this.$set('popOver.style.left', left + 'px');
            }
        },
        loadAssets: function () {
            this.$set('text_colors', JSON.parse(this.$root.getDesignerHelper().textColors));
        },
        bindSelect: function () {
            var fontSplit = this.$root.getDesignerHelper().googleFonts.styles;
            var mapGoogle = fontSplit.map(function (item) {
                return {'css_name': item.style, id: item.name, text: item.name}
            });
            var sortGoogle = _.sortBy(mapGoogle, 'text');

            function formatFont(font) {
                return $(`<span style="font-family:'${font.text}' !important;">${font.text}</span>`)
            }

            $('#selFont').select2({
                data: sortGoogle,
                formatResult: formatFont,
                formatSelection: formatFont,
                minimumResultsForSearch: -1
            });
        },
        setItalic: function () {
            var styling = this.$get('currentSelectedItem.text_block.font_style');
            if (styling == 'italic') {
                this.$set('currentSelectedItem.text_block.font_style', '');
            } else {
                this.$set('currentSelectedItem.text_block.font_style', 'italic');
            }
        },
        setBold: function () {
            var styling = this.$get('currentSelectedItem.text_block.font_weight');
            if (styling == 'bold') {
                this.$set('currentSelectedItem.text_block.font_weight', '');
            } else {
                this.$set('currentSelectedItem.text_block.font_weight', 'bold');
            }
        },
        setUnderline: function () {
            var styling = this.$get('currentSelectedItem.text_block.text_decoration');
            if (styling == 'underline') {
                this.$set('currentSelectedItem.text_block.text_decoration', '');
            } else {
                this.$set('currentSelectedItem.text_block.text_decoration', 'underline');
            }
        },
        setLeftAlign: function () {
            this.$set('currentSelectedItem.element.text_anchor', 'start');
            this.$set('currentSelectedItem.text_block.alignment_percent', '0');
        },
        setCenterAlign: function () {
            this.$set('currentSelectedItem.element.text_anchor', 'middle');
            this.$set('currentSelectedItem.text_block.alignment_percent', '50%');
        },
        setRightAlign: function () {
            this.$set('currentSelectedItem.element.text_anchor', 'end');
            this.$set('currentSelectedItem.text_block.alignment_percent', '100%');
        },
        closePopup: function () {
            this.$set('popOver.style.display', 'none');
        },
        manageFonts: function () {
            var el = this.$el;
            $(el).val();
        },
        setItemAlignVCenter: function () {
            var e = $('#' + this.currentSelectedItem.id),
                height = e.height(),
                ph = e.parent().parent().height();
            var h = (ph - height) / 2;
            this.$set('currentSelectedItem.span.top', h);
        },
        setItemAlignHCenter: function () {
            var e = $('#' + this.currentSelectedItem.id),
                width = e.width(),
                pw = e.parent().parent().width();
            var w = (pw - width) / 2;
            this.$set('currentSelectedItem.span.left', w);
        }
    }
};


// WEBPACK FOOTER //
// ./app/assets/js/client-admin/designer/components/designer_tab/controls/propertiesWindow.js